import { observable, action } from 'mobx';

import { getBuildingData, onBuildingDataChanged } from '../lib/dbCalls';

class BuildingData {
  @observable
  data: any = null;

  buildingDataChangedRef: any = null;

  @action
  async fetch(buildingId: string) {
    this.data = await getBuildingData(buildingId);
    this.listenChanges();
  }

  listenChanges() {
    this.buildingDataChangedRef = onBuildingDataChanged(this.data.id, this.onBuildingDataChanged);
  }

  @action
  onBuildingDataChanged = (snapshot: any) => {
    Object.assign(this.data, snapshot.val());
  };

  @action
  clear() {
    if (this.buildingDataChangedRef) {
      this.buildingDataChangedRef.off('value', this.onBuildingDataChanged);
    }
    this.data = null;
  }
}

export default new BuildingData();
